import { Select } from "@/components/atoms/Select";
import { FutureFlowsFiltersProps } from "./FutureFlowsFilters.types";

export const FutureFlowsFilters = ({ portfolio, year, portfolioOptions, years, setPortfolio, setYear }: FutureFlowsFiltersProps) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <Select
            label="Portafolio"
            options={portfolioOptions}
            value={portfolio}
            onChange={setPortfolio}
        />
        <Select
            label="Año"
            options={years}
            value={year}
            onChange={setYear}
        />
    </div>
);
